// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__gInjy","auto":"styles_auto___D8T6","small":"styles_small__0Ly9v","medium":"styles_medium__QMGpb","large":"styles_large__CYMzZ"};